import instance from "./instance";

export const sendOTPwithFlag = async (request) => {
    try {
        const response = await instance.post('/common/sendOTPWithFlag', request);
        return response;
    } catch (err) {
        ////     // console.log("Error : ",err);
    }
}

export const validateOTPWithFlag = async (request) => {
    try {
        const response = await instance.post('/common/validateOTPWithFlag', request);
        return response;
    } catch (err) {
        ////     // console.log("Error : ",err);
    }
}

export const getApplePaySessionAPI = (applePayRequest) =>  {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await instance.post('/applepay/session',applePayRequest);
            resolve (response);
        } catch (err) {
            reject(err);
        }
    })
}

export const getApplePayPaymentsAPI = (applePayRequest) =>  {
    //req=
    // {
    //     "paymentRequest" : {
    //     "source" : {
    //         "type" : "applepay",
    //             "token" : "tok_lku84uhtqztkeiny8b7c3hcpqa8"
    //     },
    //     "amount" : "1000",
    //         "systemId" : "MOTOR",
    //         "quotationNo" : "12245",
    //         "policyNo" : "",
    //         "tmx" : "",
    //         "reference" : "",
    //         "idNo" : "2392053266",
    //         "mobile" : "966546372656",
    //         "email" : "ksamiuddin@tawuniya.com.sa",
    //         "passportNo" : "",
    //         "lang" : "E"
    // }
    // }
    return new Promise(async (resolve, reject) => {
        try {
            const response = await instance.post('/applepay/payments',applePayRequest);
            // if(response?.data?.getSessionIdResponse?.status === "S"){
            //     let data=response?.data?.getSessionIdResponse?.sessionDetails;
            //     console.log(response?.data,'response?.data#####',response?.data?.getSessionIdResponse?.status === "S");
            //     resolve (data);
            // }else resolve ({});
            resolve (response);
        } catch (err) {
            reject(err);
        }
    })
}

export const getApplePayTokenAPI = (applePayRequest) =>  {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await instance.post('/applepay/tokens', applePayRequest);
            // if(response?.data?.getSessionIdResponse?.status === "S"){
            //     let data=response?.data?.getSessionIdResponse?.sessionDetails;
            //     console.log(response?.data,'response?.data#####',response?.data?.getSessionIdResponse?.status === "S");
            //     resolve (data);
            // }else resolve ({});
            resolve (response);
        } catch (err) {
            reject(err);
        }
    })
}


export const getPaymentOptionsTamara = async (data) => {
    try {
        const response = await instance.post('/payment/getPaymentOptionsTamara', data);
        return response;
    } catch (err) {
        //     // console.log("Error : ", err);
    }
};